import React from 'react'
import { makeStyles, Paper, Table, TableBody, TableRow, TableCell } from '@material-ui/core'
import PropTypes from 'prop-types'
import { OnChange } from 'react-final-form-listeners'
import { Form } from 'react-final-form'
import { Checkboxes } from 'mui-rff'
import QuestionHeader from './questionHeader'

const useStyles = makeStyles(() => ({
  checkbox: {
    '& .Mui-checked': {
      color: 'var(--button-color)'
    },
    '& .MuiFormControlLabel-root': {
      marginRight: '0px'
    }
  },
  done: {
    textDecoration: 'line-through',
    '& > div': {
      width: '100%'
    }
  },
  notdone: {
    '& > div': {
      width: '100%'
    }
  }
}))

export default function RenderChecklist(props) {
  const classes = useStyles()
  const { elmIndex, elm, valIndex, valueChange, allowModify } = props
  if (!elm.Value[valIndex]) elm.Value[valIndex] = {}

  const elmValueChange = (newVal, i) => {
    elm.Value[valIndex][i] = newVal
    valueChange(elmIndex, valIndex, elm.Value[valIndex])
  }
  const name = `elm-${elmIndex}-val-${valIndex}`
  const initialValues = {}

  Object.values(elm.Value[valIndex]).forEach((val, i) => {
    initialValues[name + '-' + i] = val
  })

  console.log(initialValues)
  return <div key={elmIndex} className={classes.checkbox}>
    <QuestionHeader helpTooltip={elm.ShowHelpTooltip ? elm.HelpTooltip : ''} prompt={elm.Prompt} allowBlanks={!!elm.AllowBlanks} />
    <Form onSubmit={() => { }}
      //subscription={{}}
      initialValues={initialValues}
      render={({ values }) => (<>
        <Paper elevation={1}>
          <Table className={classes.table}>
            <TableBody>
              {elm.Options && !!elm.Options.map && elm.Options.map((opt, i) =>
                <TableRow hover key={i}>
                  <TableCell className={values[name + '-' + i] ? classes.done : classes.notdone} style={{ paddingRight: '0px' }}>
                    <Checkboxes name={name + '-' + i} variant="outlined" disabled={!allowModify} data={{ label: opt }} />
                    <OnChange name={name + '-' + i}>
                      {newVal => elmValueChange(newVal, i)}
                    </OnChange>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Paper>
      </>)} //debug: <pre>{JSON.stringify(values, 0, 2)}</pre>
    />
  </div>
}
RenderChecklist.propTypes = {
  elmIndex: PropTypes.number.isRequired,
  elm: PropTypes.object.isRequired,
  valIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  valueChange: PropTypes.func.isRequired,
  allowModify: PropTypes.bool.isRequired,
}